import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const StagingMovePalletRoute: Route = {
  path: 'staging/update',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/move-pallet.component').then((m) => m.StagingMovePalletComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
